/*
 * Resolves translations for message codes and their contexts.
 */
(function() {
    'use strict';

    angular.module('paysera.toast').service('messageResolver', ErrorResolverFactory);

    ErrorResolverFactory.$inject = ['translator'];

    function ErrorResolverFactory(translator) {
        return {
            resolve: resolve
        };

        /**
         * @param {!String} message code
         * @param {!String} context period delimited string like context[.subcontext]
         * @returns {String} translation
         */
        function resolve(message, context) {
            var firstJoin = join(message, context);
            if (hasTranslation(firstJoin)) {
                return translator.trans(firstJoin);
            }

            var contexts = context.split('.');
            for (var i = contexts.length - 1; i > 0; i--) {
                var cutContexts = contexts.slice(0, i).join('.');
                var string = join(message, cutContexts);
                if (hasTranslation(string)) {
                    return translator.trans(string);
                }
            }

            return translator.trans(message);
        }

        function join(message, context) {
            if (context === '') return message;
            return context + '.' + message;
        }

        function hasTranslation(string) {
            return translator.trans(string) !== string;
        }
    }
})();
